import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { PrimengModule } from '../primeng/primeng.module';
import { FormsModule } from '@angular/forms';
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { apiConfig, b2cPolicies } from './b2c-config';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@NgModule({
    declarations: [
        LoginComponent
    ],
    exports: [
        LoginComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        PrimengModule,
        HttpClientModule,
        MsalModule.forRoot(
            new PublicClientApplication({
                auth: {
                    clientId: b2cPolicies.clientId,
                    authority: b2cPolicies.loginUrl + '/' + b2cPolicies.tenantId,
                    redirectUri: environment.redirectURL
                },
                cache: {
                    cacheLocation: 'localStorage'
                }
            }),
            {
                interactionType: InteractionType.Redirect,
                authRequest: {
                    scopes: apiConfig.scopes
                }
            }, {
                interactionType: InteractionType.Redirect,
                protectedResourceMap: new Map([
                    [environment.outgoingRequestAPI, apiConfig.scopes]
                ])
            })
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        },
        MsalGuard
    ],
    bootstrap: [MsalRedirectComponent]
})
export class AuthModule {
    public static forRoot(): ModuleWithProviders<AuthModule> {
        return {
            ngModule: AuthModule,
            providers: [
                { provide: MsalInterceptor }
            ]
        };
    }
}
